import React from 'react'
import Skeleton from 'react-loading-skeleton'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const QuoteModule = ({ data, titleColor="blue" }) => {
    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        fade: true,          // ✅ enables fade effect
        cssEase: "linear"
    };
    return (
        <div className='slider_wrapper coop_member_text mt-4'>
            <hr style={{ backgroundColor: '#E4E4E4', opacity: '1' }} />
            <blockquote className='sec-bg-dark-grey text-center'>
                <Slider {...settings}>
                    {data?.map?.((item, index)=>(
                        <div key={index} className='slider_slide_item'>
                            <h2 className={`text-${titleColor} fw-500 fs_60 mb-0`}>{item?.Text}</h2>
                            {item?.Titel && <h4 className="text-darkgrey fw-550 fs_26">{item?.Titel}</h4>}
                        </div>
                    ))}
                </Slider>
            </blockquote>
            <hr style={{ backgroundColor: '#E4E4E4', opacity: '1' }} />
        </div>
    )
}

export default QuoteModule